/* eslint react/no-unescaped-entities: 0 */
/* eslint react/display-name: 0 */
import React, { Component } from "react";
import ImportInstallationsContent from "./ImportInstallationsContent";
import { ROUTE_COMPRESSORS_IMPORT } from "../../../../routes";

export default class extends Component {
  static propTypes = ImportInstallationsContent.propTypes;

  /**
   * {@inheritdoc}
   */
  render() {
    return (
      <div>
        <p>
          Um den Import Ihrer Anlagen durchzuführen, müssen die Daten in
          ODS- oder TSV-Format gespeichert werden und die folgende Struktur einhalten:
        </p>

        <ul>
          <li>Kunden-Nr. <i>(optional) - Wenn eine Anlagenzeile keine Kundennummer hat, wird die Anlage für das Kundenkonto erstellt, dem Sie zugeordnet sind.</i></li>
          <li>Standort-Nummer</li>
          <li>Anlagen Nr.</li>
          <li>
            Kältemittel
          </li>
          <li>
            Öl <i>(optional)</i>
          </li>
          <li>
            Wärmeträger <i>(optional)</i>
          </li>
          <li>Bezeichnung</li>
          <li>Nennfüllmenge</li>
          <li>Aktuelle Füllmenge</li>
          <li>
            Bezeichner num <i>(optional)</i>
          </li>
          <li>Markierung</li>
          <li>Datum der Inbetriebnahme</li>
          <li>Datum der letzten wiederkehrenden Prüfung</li>
          <li>
            Indirekter Lecksuchgerät <i>(0 = kein Detektor | 1 = Detektor vorhanden)</i>
          </li>
        </ul>
        <small>Felder, die nur erforderlich sind, wenn ein Kompressor zur Anlage hinzugefügt wird:</small>
        <ul>
          <li>Kompressor: Markierung</li>
          <li>Kompressor: Bezeichner num <i>(optional)</i></li>
          <li>Kompressor: Seriennummer <i>(optional)</i></li>
          <li>Kompressor: Typ</li>
          <li>Kompressor: Klassifikation</li>
          <li>Kompressor: Marke <i>(optional)</i></li>
        </ul>

        <p>{this.props.downloadSample}</p>

        <p>
          Um mehrere Kompressoren in eine Anlage zu importieren, <a href={ROUTE_COMPRESSORS_IMPORT}>klicken Sie hier</a>.
        </p>

        <p>
          Nach der Integration informiert Sie eine Zusammenfassung über die Anzahl der erstellten oder aktualisierten Entitäten und stellt eine Anomaliedatei bereit, die die nicht integrierten Zeilen sowie die Gründe für die Ablehnung enthält.
        </p>

        <p>Die möglichen Gründe für Anomalien sind:</p>

        <ul>
          <li>Fehlende Pflichtdaten</li>
          <li>Flüssigkeit, Öl oder Wärmeträger nicht vorhanden</li>
          <li>Wert unterscheidet sich von 1/0</li>
          <li>Ungültiges Datum</li>
          <li>Kompressor: Typ, Klassifikation oder Marke nicht vorhanden</li>
        </ul>
      </div>
    );
  }
}
